export var InnovyzeEntitlement;
(function (InnovyzeEntitlement) {
    InnovyzeEntitlement["AM_DASHBOARD"] = "AMDashboard";
    InnovyzeEntitlement["AM_MAP"] = "AMMap";
    InnovyzeEntitlement["AM_INSPECTIONS"] = "AMInspections";
    InnovyzeEntitlement["AM_RISK"] = "AMRisk";
    InnovyzeEntitlement["AM_GISIMPORT"] = "AMGISImport";
})(InnovyzeEntitlement || (InnovyzeEntitlement = {}));
